import { DesignStudioDashboardRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The `design-studio_` (trailing underscore) segment keeps this route OUT of
// the `design-studio.tsx` layout route, which renders only the not-found fallback
// without an Outlet — a nested child's component would never
// render. As a static path, `/design-studio/dashboard` outranks the
// `/design-studio/$` splat, so this route wins the match for the dashboard URL.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/design-studio_/dashboard')({
  component: DesignStudioDashboardRoute,
});
